export const Logo = ({ size = 34 }) => (
  <span className="inline-flex items-center" data-testid="nav-logo">
    <img
      src="/images/ahq-logo-white.png"
      alt="Agency HQ"
      style={{ height: Math.round(size * 0.82), width: "auto" }}
      onError={(e) => {
        e.currentTarget.style.display = "none";
      }}
    />
  </span>
);

export default Logo;
